//Author June Leow
//Date Mar 22nd, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, generateTooltip, showMessage} from '../../../../util/util';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import {Card, CardHeader, CardBody, Input} from 'reactstrap';
import MySelect from '../../../util/my-select';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {

};


const exteriorUpdatedComponentEnum = [
  {value:'NONE_OBSERVED', label:'None Observed'}, 
  {value:'SIDING', label:'Siding'}, 
  {value:'DOORS', label:'Doors'}, 
  {value:'WALLS', label:'Walls'}, 
  {value:'ROOF', label:'Roof'}, 
  {value:'FOUNDATION', label:'Foundation'}, 
  {value:'FENCE', label:'Fence'}, 
  {value:'OTHER', label:'Other'}, 
  {value:'WINDOWS', label:'Windows'}, 
];

const exteriorUpdateTypeEnum = [
  {value:'FULLY_UPDATED', label:'Fully Updated'}, 
  {value:'PARTIALLY_UPDATED', label:'Partially Updated'}, 
];

const exteriorUpdateTimeframeEnum = [
  {value:'LESS_THAN_1_YEAR', label:'Less Than 1 Year'}, 
  {value:'1_TO_10_YEARS', label:'1 to 10 Years'}, 
  {value:'10_TO_20_YEARS', label:'10 to 20 Years'}, 
  {value:'MORE_THAN_20_YEARS', label:'More Than 20 Years'}, 
];

const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update
const reducer = getReducer();


const ExteriorUpdates  = (props)=>{
  const controller = new AbortController();

  const [,dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const getCompressRatio = (size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop = (acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{
    // let limit = 3;
    //
    // if(type==='Floor Plan')
    //   limit = 1;
    //
    // if(props[field].length+ acceptedFiles.length>limit){
    //   let numberOfAvailable = limit - props[field].length;
    //   acceptedFiles = acceptedFiles.slice(0, numberOfAvailable);
    //   showMessage('error', 'Maximum number of photo uploaded and could not accept any more photos.');
    // }

    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let exteriorUpdates = newUPD.property.buildings[props.index].exteriorUpdates.slice();
   
                let target = exteriorUpdates[index][field]?exteriorUpdates[index][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:exteriorUpdates[index].ID, description:description});
                exteriorUpdates[index][field] = target;
                newUPD.property.buildings[props.index].exteriorUpdates = exteriorUpdates;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const updateFileDescription = (index, index2, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let exteriorUpdates = newUPD.property.buildings[props.index].exteriorUpdates.slice();
    let target = exteriorUpdates[index][field]?exteriorUpdates[index][field]:[];
    if(target &&  target[index2]){
      target[index2].description = description;
    }

    newUPD.property.buildings[props.index].exteriorUpdates = exteriorUpdates;
    props.update(newUPD);
  }

  const removeFile = (field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let exteriorUpdates = newUPD.property.buildings[props.index].exteriorUpdates.slice();
    let target = exteriorUpdates[index][field].slice();

    let targetToDelete = target[index2];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index2, 1);
        exteriorUpdates[index][field] = target;
        newUPD.property.buildings[props.index].exteriorUpdates = exteriorUpdates;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index2, 1);
      exteriorUpdates[index][field] = target;
      newUPD.property.buildings[props.index].exteriorUpdates = exteriorUpdates;
      props.update(newUPD);
    }
  }

  const getExteriorUpdatesLabel = (value)=>{
    console.log(value)
    for(let i=0;i<exteriorUpdatedComponentEnum.length;i++){
      if(exteriorUpdatedComponentEnum[i].value===value)
        return exteriorUpdatedComponentEnum[i].label;
    }

    return value;
  }

  const updateExteriorUpdatesDetail = (index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let exteriorUpdates = newUPD.property.buildings[props.index].exteriorUpdates.slice();
    exteriorUpdates[index][field] = value;
    newUPD.property.buildings[props.index].exteriorUpdates = exteriorUpdates;
    props.update(newUPD);
  }

  const updateExteriorUpdates = (value)=>{
    let newUPD = Object.assign({}, props.upd);
    let exteriorUpdates = newUPD.property.buildings[props.index].exteriorUpdates?newUPD.property.buildings[props.index].exteriorUpdates.slice():[];

    if(value==='NONE_OBSERVED'){
      exteriorUpdates = [{exteriorUpdatedComponent:value}];
    }
    else{
      for(let i=0;i<exteriorUpdates.length;i++){
        if(exteriorUpdates[i].exteriorUpdatedComponent==='NONE_OBSERVED'){
          exteriorUpdates = [];
          break;
        }
      }
      exteriorUpdates.push({exteriorUpdatedComponent:value, imageExteriorUpdate:[]});
    }
    console.log(exteriorUpdates)
    newUPD.property.buildings[props.index].exteriorUpdates = exteriorUpdates;
    props.update(newUPD);
  }

  const removeExteriorUpdates = (index)=>{
    let newUPD = Object.assign({}, props.upd);
    let exteriorUpdates = newUPD.property.buildings[props.index].exteriorUpdates.slice();
    exteriorUpdates.splice(index, 1);
    newUPD.property.buildings[props.index].exteriorUpdates = exteriorUpdates;
    props.update(newUPD);
  }

  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }

  //render
  return (<div>
    <label>{!props.disabled?<font color="red">*</font>:null}Select any applicable exterior component(s) that have been updated. {generateTooltip('exteriorUpdatedComponent', 'User to select any exterior item(s) / component(s) of the structure that have been updated from their original state.')}</label>
    <MySelect
      type="select"
      required={!props.disabled}
      disabled={props.disabled}
      style={props.disabled?disabledStyling:{}}
      value={props.upd.property.buildings[props.index].exteriorUpdates && props.upd.property.buildings[props.index].exteriorUpdates.length>0?" ":""}
      onChange={(v)=>updateExteriorUpdates(v)}
      options={exteriorUpdatedComponentEnum}
    />
    <br/>
    {
      props.upd.property.buildings[props.index].exteriorUpdates.map(
        (exteriorUpdate, index)=>{
          console.log(exteriorUpdate)
          if(exteriorUpdate.exteriorUpdatedComponent==='NONE_OBSERVED'){
            return <div key={index} style={{marginTop:'15px'}}>
              <b>None Observed</b>
            </div>
          }

          return (
            <div key={index} style={{marginTop:"10px"}}>
              <Card>
                <CardHeader>
                  <i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeExteriorUpdates(index)}/> {getExteriorUpdatesLabel(exteriorUpdate.exteriorUpdatedComponent)} Exterior Update
                </CardHeader>
                <CardBody>
                  <label>{!props.disabled?<font color="red">*</font>:null}Select to what degree the exterior component was updated. {generateTooltip('exteriorUpdateType'+index,'Indicate to what degree the component(s) have been updated, if there have been updates to the exterior of the structure.')}</label>
                  <MySelect
                    type="select"
                    required={!props.disabled}
                    disabled={props.disabled}
                    style={props.disabled?disabledStyling:{}}
                    value={exteriorUpdate.exteriorUpdateType}
                    onChange={(v)=>updateExteriorUpdatesDetail(index, 'exteriorUpdateType', v)}
                    options={exteriorUpdateTypeEnum}
                  />
                  <br/>

                  <label>{!props.disabled?<font color="red">*</font>:null}How long ago was the update to the exterior was completed?</label>
                  <MySelect
                    type="select"
                    required={!props.disabled}
                    disabled={props.disabled}
                    style={props.disabled?disabledStyling:{}}
                    value={exteriorUpdate.exteriorUpdateTimeframe}
                    onChange={(v)=>updateExteriorUpdatesDetail(index, 'exteriorUpdateTimeframe', v)}
                    options={exteriorUpdateTimeframeEnum}
                  />
                  <br/>
                  <label>{!props.disabled?<font color="red">*</font>:null}Provide a concise description of each deficiency observed. {generateTooltip('exteriorUpdateDescription'+index, 'User to provide a concise text description of any deficiencies observed.')}</label>
                  <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={exteriorUpdate.exteriorUpdateDescription} onChange={(e)=>updateExteriorUpdatesDetail(index,'exteriorUpdateDescription', e.target.value)}/>
                  <br/>
                  <div className="my-divider"/>
                  <br/>
                  <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of exterior update</label>
                  <br/>
                  <input
                    tabIndex={-1}
                    autoComplete="off"
                    style={{ opacity: 0, height: 0, width:0 }}
                    value={exteriorUpdate.imageExteriorUpdate&&exteriorUpdate.imageExteriorUpdate.length>0?" ":""}
                    required={!props.disabled}
                  />
                  <div>
                    <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageExteriorUpdate', exteriorUpdate.exteriorUpdatedComponent+'_EXTERIOR_UPDATE', 0)}} className="my-dropzone">
                    {
                      ({getRootProps, getInputProps}) => (
                        <div
                          {...getRootProps({
                            className: 'my-dropzone',
                          })}
                        >
                          <input {...getInputProps()} />
                          <center>Choose files to upload</center>
                        </div>
                      )
                    }
                    </Dropzone>
                    {
                      !exteriorUpdate.imageExteriorUpdate?null:exteriorUpdate.imageExteriorUpdate.map(
                        (photo, index2)=>{
                          return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                            <div>
                              <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageExteriorUpdate',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                            </div>
                            <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                            <div style={{marginTop:'5px'}}/>
                            {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageExteriorUpdate', e.target.value)}/>
                            <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                          </div>
                        }
                      )
                    }
                  </div>
                </CardBody>
              </Card>
            </div>
          )
        }
      )
    }
    
  </div>);
}


export default ExteriorUpdates;